import { Button, Typography } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { Link } from "react-router-dom";

export default function SignedInSearch() {
  return (
    <div className="w-full bg-white border-b border-gray-200">
      <div className="max-w-[1200px] mx-auto px-4 py-8 flex flex-col items-center gap-4">
        <Typography variant="h6" className="font-semibold text-center">
          Find your next product partner
        </Typography>

        <div className="flex flex-wrap gap-3 items-center justify-center">
          <div className="relative">
            <input
              type="text"
              placeholder="Face"
              className="border border-gray-300 rounded-md px-4 py-2 w-80 focus:outline-none focus:ring-2 focus:ring-teal-600"
            />
            <SearchIcon className="absolute right-3 top-3 text-gray-500" />
          </div>

          {/* <Button
            variant="contained"
            sx={{ backgroundColor: "#004C66", textTransform: "uppercase" }}
          >
            Search
          </Button> */}

          <Link
            to="/searchResults"
            className="items-center rounded-xl bg-blue-600 px-6 py-2.5 text-white shadow hover:bg-blue-700 transition duration-200"
          >
            Search
          </Link>

          {/* <Button
            variant="contained"
            sx={{ backgroundColor: "#004C66", textTransform: "uppercase" }}
          >
            Advanced Search
          </Button> */}
        </div>
      </div>
    </div>
  );
}
